import { DateTime } from "luxon";

import DateRangePicker from "../form/DateRangePicker";

export default (props: {
  startDate: string;
  endDate: string;
  onChange: (startDate: string, endDate: string) => void;
}): JSX.Element => {
  // Usage always uses PT for days since that's how we handle billing
  const timezone = "America/Los_Angeles";
  const now = DateTime.now().setZone("America/Los_Angeles");

  return (
    <DateRangePicker
      {...props}
      timezone={timezone}
      shortcuts={[
        {
          title: "This Month",
          startDate: now.startOf("month").toISODate(),
          endDate: now.endOf("month").toISODate()
        },
        {
          title: "Last Month",
          startDate: now.minus({ months: 1 }).startOf("month").toISODate(),
          endDate: now.minus({ months: 1 }).endOf("month").toISODate()
        }
      ]}
    />
  );
};
